/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ExchangeSessionTokenRequest} from '@cash-web/protos/squareup/cash/janus/api/ExchangeSessionTokenProto.pb'
import {ExchangeSessionTokenResponse} from '@cash-web/protos/squareup/cash/janus/api/ExchangeSessionTokenProto.pb'


export const exchangeSessionTokenInternal = (request: ExchangeSessionTokenRequest, options?: CashRequestOptions) => post<ExchangeSessionTokenRequest, ExchangeSessionTokenResponse>("/2.0/cash/exchange-session-token-internal", request, {...options, rejectOnError: true })